module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/sg-9751741f84e6e5263a407b127b7d782b.svg";